import { render } from "./UserInfoView.vue?vue&type=template&id=2f9051e0&scoped=true"
import script from "./UserInfoView.vue?vue&type=script&lang=js"
export * from "./UserInfoView.vue?vue&type=script&lang=js"

import "./UserInfoView.vue?vue&type=style&index=0&id=2f9051e0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9051e0"]])

export default __exports__